import { createContext, useContext } from "react";

export type ThemePreference = "light" | "dark";
export type ResolvedTheme = "light" | "dark";

export type ThemeContextValue = {
  /** What the user picked. */
  preference: ThemePreference;
  /** What is actually on screen right now. */
  theme: ResolvedTheme;
  setPreference: (next: ThemePreference) => void;
};

/* The context and its hook live apart from the provider component so that
   editing ThemeProvider.tsx still hot-reloads: fast refresh only keeps state
   for modules that export components and nothing else. */
export const ThemeContext = createContext<ThemeContextValue | null>(null);

export function useTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used inside <ThemeProvider>");
  return ctx;
}
